import React from 'react';
import { Timeline } from 'antd'; // 导入 Timeline
import { useTranslation } from 'react-i18next';
import './OrderStatusSection.scss';
import { OrderStatusLog } from 'types/dto/order';
import { DATETIME_MM_DD_FORMAT, formatDateTime } from 'constants/consts';

interface OrderStatusSectionProps {
  statusHistory?: OrderStatusLog[];
}

const OrderStatusSection: React.FC<OrderStatusSectionProps> = ({ statusHistory = [], }) => {
  const { t } = useTranslation('order_history');

  const timelineItems = statusHistory.map((item, index) => ({
    dot: (
      <div className={`timeline-dot ${index === 0 ? 'active' : 'inactive'}`} />
    ),
    children: (
      <div className="timeline-content">
        <div className={`status-text ${index === 0 ? 'active' : 'inactive'}`}>
          {item.statusName}
        </div>
        <div className="status-date">
          {formatDateTime(item.changeTime, DATETIME_MM_DD_FORMAT)}
        </div>
      </div>
    ),
  }));

  return (
    <div className="order-status-section">
      <div className="vls-section-title order-status-title">
        {t('orderStatus')}
      </div>

      <Timeline items={timelineItems} className="order-status-timeline" />
    </div>
  );
};

export default OrderStatusSection;